import { ModuleConfiguration } from 'src/app/app.module';
import { SensorLocalizationConfigComponent } from '../config/sensor-localization-config.component';

export const SENSOR_LOCALIZATION_MODULE_DETAILS: ModuleConfiguration = {
  displayName: 'Verortung Sensoren',
  previewImagePath: 'assets/orthophoto_preview.png',
  settingsComponent: SensorLocalizationConfigComponent,
};
